// extracted by mini-css-extract-plugin
export default {"button":"TransparentButton-module__button__IKlFL"};